import { CdkCopyToClipboard } from '@angular/cdk/clipboard'
import { NgTemplateOutlet } from '@angular/common'
import { Component, computed, input, signal } from '@angular/core'

import { TagModule } from 'primeng/tag'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import { UiFlowSessionState } from '@flowx/core-sdk'
import { uiFlowStatusTagTypeMap } from '@flowx/designer/modules/core/dictionary/common.types'
import { FlxTableDateFormatPipe } from '@flowx/designer/pipes/flx-date.pipe'

@Component({
  selector: 'flx-ui-flow-session-details-panel-header',
  imports: [
    FlxButtonModule,
    FlxIconModule,
    CdkCopyToClipboard,
    TagModule,
    NgTemplateOutlet,
    FlxTableDateFormatPipe,
  ],
  templateUrl: './ui-flow-session-details-panel-header.component.html',
  styleUrl: './ui-flow-session-details-panel-header.component.scss',
})
export class UiFlowSessionDetailsPanelHeaderComponent {
  name = input.required<string>()
  uuid = input.required<string>()
  state = input.required<UiFlowSessionState>()
  /** `strip` is the bottom panel's one-line header; `card` is the session page's identity card. */
  layout = input<'strip' | 'card'>('strip')
  /** Shown in the `card` layout only. */
  dateStarted = input<string>(null)

  severity = computed(() => {
    const state = this.state()
    return uiFlowStatusTagTypeMap[state] || 'info'
  })

  copiedTextToClipboard = signal(false)

  onCopyToClipboardSuccess(): void {
    this.copiedTextToClipboard.set(true)
    setTimeout(() => this.copiedTextToClipboard.set(false), 2000)
  }
}
